/**
 * Per-tab memory of the worklist's clinic filter (super-admin / multi-clinic
 * QoL). Every navigation back to a bare /study/list — the viewer's Study List
 * button, the sidebar, a teleconsultation round trip — used to reset the
 * clinic filter to "all clinics", which is a constant irritation when working
 * (or demoing) as one clinic. The chosen clinic code is remembered per tab
 * and re-applied when the worklist mounts without one; explicitly choosing
 * "All clinics" forgets it. Cleared on logout.
 */
const CLINIC_FILTER_KEY = 'worklist.clinicCode';
export function rememberClinicFilter(clinicCode) {
    try {
        sessionStorage.setItem(CLINIC_FILTER_KEY, clinicCode);
    }
    catch {
        // Storage unavailable — the filter simply won't stick; never throw.
    }
}
export function recallClinicFilter() {
    try {
        return sessionStorage.getItem(CLINIC_FILTER_KEY);
    }
    catch {
        return null;
    }
}
export function forgetClinicFilter() {
    try {
        sessionStorage.removeItem(CLINIC_FILTER_KEY);
    }
    catch {
        // Storage unavailable — nothing was stored anyway.
    }
}
